$(function() {
    AOS.init();
});
